import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  LoadPreviewListCols,
  NavigateToCustomer,
  NavigateToMember,
  PreviewListByFilterSuccess,
  PreviewListForMembersSuccess,
  PreviewListForPersonSuccess,
  PreviewListPagingChanged,
  PreviewListForMembers,
  PreviewListForPerson,
} from '../actions/preview-list.actions';
import { CloseSidenav } from '../actions/sidenav.actions';

export interface PreviewListState extends EntityState<any> {
  displayedColumns: { [label: string]: string };
  loyaltyMemberId: number | null;
  totalResults: number;
  itemsNumber: number;
  paginator: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  };
  personId: number | null;
  campaignAdHocListId: number | null;
}

export const previewListAdapter = createEntityAdapter<any>();

const initialState: PreviewListState = previewListAdapter.getInitialState({
  displayedColumns: {},
  loyaltyMemberId: null,
  totalResults: 0,
  itemsNumber: 10,
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
  personId: null,
  campaignAdHocListId: null,
});

export const PreviewListReducer = createReducer(
  initialState,
  on(LoadPreviewListCols, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(PreviewListForMembersSuccess, (state, { res }) => {
    const data = res.map((member: any) => ({
      id: member.id,
      lastName: member.lastName,
      firstName: member.firstName,
      loyaltyCard: member.loyaltyCard,
      points: member.points,
      schemaId: member.schemaId,
      smsOptOut: member.smsOptOut,
      emailOptOut: member.emailOptOut,
    }));

    return previewListAdapter.setAll(data, { ...state });
  }),
  on(PreviewListForPersonSuccess, (state, { res }) => {
    const data = res.map((member: any) => ({
      id: member.id,
      lastName: member.lastName,
      firstName: member.firstName,
      email: member.email,
      mobile: member.mobile,
      smsOptOut: member.smsOptOut,
      emailOptOut: member.emailOptOut,
    }));

    return previewListAdapter.setAll(data, { ...state });
  }),
  on(NavigateToMember, (state, { loyaltyMemberId }) => ({
    ...state,
    loyaltyMemberId,
  })),
  on(PreviewListByFilterSuccess, (state, { res }) => ({
    ...state,
    totalResults: res,
  })),
  on(CloseSidenav, () => initialState),
  on(NavigateToCustomer, (state, { personId }) => ({
    ...state,
    personId,
  })),
  on(PreviewListPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(PreviewListForMembers, (state, { campaignAdHocListId }) => ({
    ...state,
    campaignAdHocListId,
  })),
  on(PreviewListForPerson, (state, { campaignAdHocListId }) => ({
    ...state,
    campaignAdHocListId,
  })),
);
